import { INewbuilding } from '../../types/newbuilding';

export function getNewbuildingImages(newbuilding: INewbuilding) {
  return newbuilding.images || [];
}
